import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 三级分组
export function getlistAllGroup(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/gateway/groups',
    method: 'get',
    params
  })
}

// 查询所有厂牌(何吕写的暂时不用)
// export function getlistAllLabel(params) {
//   return axios.request({
//     url: urlObj.wss + 'wss-part/parts/carBrand/findAllByFc',
//     method: 'get',
//     params
//   })
// }
export function getlistAllLabel(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/car/brand/first/char',
    method: 'get',
    params
  })
}
// 查询所有车系
export function getListCarSeries(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/car/brand/groups',
    method: 'get',
    params
  })
}

// 查询所有车型
export function getCarModel(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/findCarModelBySeriesIdIdAndName',
    method: 'get',
    params
  })
}

// 搜配 品牌
export function getSoPeiCarBrandList(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/sopei/v1.0/getSoPeiCarBrandList',
    method: 'get',
    params
  })
}
// 搜配 车系
export function getSoPeiFactoryModel(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/sopei/v1.0/getSoPeiFactoryModel',
    method: 'post',
    data
  })
}

// 搜配 车型
export function getSoPeiDisplacementYear(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/sopei/v1.0/getSoPeiDisplacementYear',
    method: 'post',
    data
  })
}
